import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';

const LazyInlineDatePicker = (props) => {
    const [LazyComponent, setLazyComponent] = useState(null);

    useEffect(() => {
        if (!LazyComponent) {
            const LazyLoadedComponent = loadable(
                () => import('./InlineDatePicker'),
                {
                    fallback: <div />,
                },
            );

            setLazyComponent(LazyLoadedComponent);
        }
    }, []);

    return LazyComponent ? <LazyComponent {...props} /> : null;
};

export default LazyInlineDatePicker;
